export default __webpack_public_path__ + "static/media/photo--sm--56.2583754a.jpg";